document.querySelectorAll('.nexgi-seo-content-read-more').forEach(function(wrapper) {
    var content = wrapper.querySelector('.m-richtext__description');
    if (!content) return;

    var fullHTML = content.innerHTML;

    var plainText = fullHTML
        .replace(/<\/(h1|h2|h3|h4|h5|h6|p|div|li)>/gi, ' ')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    if (plainText.length <= 150) return;

    var fontSize = parseFloat(window.getComputedStyle(content).fontSize);
    var avgCharWidth = fontSize * 0.6;
    var charsPerLine = Math.floor(content.offsetWidth / avgCharWidth);
    var maxChars = Math.floor(charsPerLine * 4);

    var shortText = plainText.substring(0, maxChars) + '...';

    content.innerHTML = '<span style="margin-right:6px">' + shortText + '</span><a href="#" class="nexgi-read-more-btn">Read More</a>';

    wrapper.addEventListener('click', function(e) {
        if (!e.target.classList.contains('nexgi-read-more-btn')) return;
        e.preventDefault();

        if (e.target.textContent === 'Read More') {
            content.innerHTML = fullHTML + '<a href="#" class="nexgi-read-more-btn">Read Less</a>';
        } else {
            content.innerHTML = '<span style="margin-right:6px">' + shortText + '</span><a href="#" class="nexgi-read-more-btn">Read More</a>';
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });
});